import React, { useState, useRef, useCallback } from 'react';
import { Link, useHistory } from "react-router-dom";
import Form, {
    Item,
    Label,
    ButtonItem,
    ButtonOptions,
    RequiredRule,
    EmailRule
} from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
import notify from 'devextreme/ui/notify';
import auth from '../../api/auth';
import { CheckBox } from 'devextreme-react/check-box';
import { GroupItem } from 'devextreme-react/form';
import './subscribe.scss';

// const notificationText = 'We\'ve sent a link to reset your password. Check your inbox.';

export default function ResetPasswordForm(props) {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const formData = useRef({});
    const [isAgreed, setIsAgreed] = useState(false);
    const [isAgreed2, setIsAgreed2] = useState(false);

    const onSubmit = useCallback(async (e) => {
        e.preventDefault();
        const { 
            'First Name': firstName, 
            'Last Name': lastName, 
            'Email': email, 
            'Phone Number': phone 
        } = formData.current;
        console.log("firstName, lastName, email, phone",firstName, lastName, email, phone)
        setLoading(true);

        const result = await auth.subscribe(firstName, lastName, email, phone);
        setLoading(false);

        if (result.isOk) {
            history.push('/login');
            notify(`SUCCESS: RedLore will verify your request to access RedBoard.   Once approved, you will receive and email with instructions on how to log-into RedBoard`, 'success', 15000);
        } else {
            notify(`ERROR: ${result.message}`, 'error', 15000);
        }
    }, [history]);

    const handleChange = (e) => {
        setIsAgreed(e.value);
    };

    const handleChange2 = (e) => {
        setIsAgreed2(e.value);
    };

    return (
        <form className={'reset-password-form'} onSubmit={onSubmit}>
            <Form formData={formData.current} disabled={loading}>
                <GroupItem colCount={2}>
                    <Item
                        dataField={'First Name'}
                        editorType={'dxTextBox'}
                        editorOptions={firstNameEditorOptions}
                    >
                        <RequiredRule message="First Name is required" />
                        <Label visible={true} />
                    </Item>

                    <Item
                        dataField={'Last Name'}
                        editorType={'dxTextBox'}
                        editorOptions={lastNameEditorOptions}
                    >
                        <RequiredRule message="Last Name is required" />
                        <Label visible={true} />
                    </Item>
                </GroupItem>
                <Item
                    dataField={'Email'}
                    editorType={'dxTextBox'}
                    editorOptions={emailEditorOptions}
                >
                    <RequiredRule message="Email is required" />
                    <EmailRule message="Email is invalid" />
                    <Label visible={true} />
                </Item>
                <Item
                    dataField={'Phone Number'}
                    editorType={'dxTextBox'}
                    editorOptions={phoneEditorOptions}
                >
                    <Label visible={true} />
                </Item>
                <Item>
                    <div className='subscribe-checkbox-container'>
                        <CheckBox className='subscribe-checkbox' defaultValue={false} onValueChanged={handleChange} />
                        <p>
                            By checking, you are allowing to receive transactional/informational SMS communications regarding account notifications, customer care, etc, from Redlore Inc. Message frequency may vary. Message and data rates may apply, reply HELP for help or STOP to opt-out.
                        </p>
                    </div>
                    <div className='subscribe-checkbox-container'>
                        <CheckBox className='subscribe-checkbox' defaultValue={false} onValueChanged={handleChange2} />
                        <p> By checking, I accept &nbsp;
                            <a
                                href="https://redlore.com/elementor-5453/"
                                className="privacy-link"
                                target="_blank"
                                rel="noreferrer"
                            > 
                                Terms of Service
                            </a>
                            &nbsp; & &nbsp;
                            <a
                                href="https://redlore.com/privacy"
                                className="privacy-link"
                                target="_blank"
                                rel="noreferrer"
                            > 
                                Privacy Policy
                            </a>
                        </p>
                    </div>
                </Item>

                <ButtonItem>
                    <ButtonOptions
                        elementAttr={submitButtonAttributes}
                        width={'100%'}
                        type={'default'}
                        useSubmitBehavior={true}
                        disabled={loading || !isAgreed2}
                    >
                        <span className="dx-button-text">
                            {
                                loading
                                    ? <LoadIndicator width={'24px'} height={'24px'} visible={true} />
                                    : 'Subscribe'
                            }
                        </span>
                    </ButtonOptions>
                </ButtonItem>
            </Form>

        </form>
    );
}

const firstNameEditorOptions = { stylingMode: 'filled', placeholder: 'First...' };
const lastNameEditorOptions = { stylingMode: 'filled', placeholder: 'Last...' };
const emailEditorOptions = { stylingMode: 'filled', placeholder: 'Email...', mode: 'email' };
const phoneEditorOptions = { stylingMode: 'filled', placeholder: 'Optional' };
const submitButtonAttributes = { class: 'submit-button' };
